export default __webpack_public_path__ + "static/media/guide_042.d538f66d.md";